import { Children, cloneElement, useState } from 'react';

import {
  useApplicationsGetQueryById,
  useApplicationsPutQueryById,
} from '../../Common/Queries/applicationsQueries';
import {
  useInterviewsGetQueryById,
  useInterviewsPutQueryById,
} from '../../Common/Queries/interviewsQueries';
import { usePositionsGetQueryById } from '../../Common/Queries/positionsQueries';
import { useTemplatesGetQueryByIds } from '../../Common/Queries/templateQueries';

import { getInterviewByIdMap } from '../../utils/responseMap.ts';

export const formateData = (value, reason, status, teamID) => {
  if (reason.replace(/(<([^>]+)>)|\n|&nbsp;/gi, '') === '') {
    return { ...value, reason: '', status, teamID };
  }
  return { ...value, reason, status, teamID };
};

export const formateInterviewData = (data, text, status, mentionedUsers = []) => {
  let message = '';
  if (text.replace(/(<([^>]+)>)|\n|&nbsp;/gi, '') !== '') {
    message = text;
  }
  const basicInfo = {
    round: data?.round,
    status: status || data?.status,
    text: message,
  };
  const interviewDetails = {
    location: data?.location || 'ONLINE',
    duration: data?.duration,
    interviewer: data?.interviewer,
    startTime: data?.startTime,
  };
  const otherDetails = {
    versionKey: data?.versionKey,
    message: data?.message || '',
    customLink: data?.customLink || '',
    timeZone: data?.timeZone || 'Asia/Kolkata',
  };
  return {
    application: data?.application,
    otherDetails,
    interviewDetails,
    basicInfo,
    userIDs: Array.from(new Set(mentionedUsers)),
  };
};

export function ActionsContainer({ children, applicationData, linkID, ...props }) {
  const child = Children.only(children);
  const { id, allowedOperations } = applicationData?.interview || 0;

  const [open, setOpen] = useState(false);

  const handleOpen = (openValue) => {
    setOpen(openValue);
  };

  const putToApplication = useApplicationsPutQueryById();
  const interview = useInterviewsGetQueryById(
    linkID === applicationData?.id &&
      open &&
      (allowedOperations?.includes('PASS') ||
        (applicationData?.interview?.round === 'HR SCREENING' &&
          applicationData?.interview?.status === 'PENDING')) &&
      !['NEW', 'PENDING OFFER', 'OFFERED', 'DUPLICATE'].includes(applicationData?.status) &&
      id,
    {
      select: (data) => getInterviewByIdMap(data),
    }
  );
  const { data: interviewData } = interview;
  const putToInterview = useInterviewsPutQueryById();

  const handlePutApplication = (status, reason, teamID) => {
    const reqBody = formateData(applicationData, reason, status, teamID);
    const reqParams = {
      reqBody,
      reqId: applicationData.id,
    };
    putToApplication.mutate(reqParams);
  };

  const handlePutInterview = (status, reason, mentionedUsers) => {
    const reqBody = formateInterviewData(interviewData, reason, status, mentionedUsers);
    putToInterview.mutate({ reqBody, reqId: id });
  };

  const applicationResponse = useApplicationsGetQueryById(applicationData.id);

  const positionResponse = usePositionsGetQueryById(
    {
      reqId: applicationResponse?.data?.position?.id,
    },
    {
      enabled: !!applicationResponse?.data?.position?.id, // wait until application is fetched
    }
  );

  const olTemplateIDs = positionResponse?.data?.templateID || [];

  const olTemplates = useTemplatesGetQueryByIds(olTemplateIDs, {
    enabled: !!positionResponse?.data?.templateID,
  });
  return cloneElement(child, {
    handlePutApplication,
    handlePutInterview,
    applicationData,
    putToApplication,
    putToInterview,
    interview,
    handleOpen,
    olTemplates: olTemplates.map((res) => res.data),
    ...props,
  });
}
